export default __webpack_public_path__ + "309a76e2b6629102c21f1814c784b860.png";